module.exports = __webpack_public_path__ + "static/media/mama-burger2-mb-en.d79929c5.jpg";